import Button from '@/components/Button';
import Heading from '@/components/renderers/Heading';
import Paragraph from '@/components/renderers/Paragraph';

export default function SectionHero({
  pretext,
  title,
  description,
  ctas,
  noHr,
}) {
  return (
    <div className="lg:text-center mb-6 lg:mb-12 mx-auto max-w-4xl">
      {!noHr && (
        <hr className="inline-block bg-cornflower border-0 h-1 rounded w-24 md:w-48" />
      )}

      {pretext && (
        <p className="text-cornflower text-xs -mb-8 uppercase tracking-wide font-semibold">
          {pretext}
        </p>
      )}

      {title && <Heading level={2}>{title}</Heading>}
      {description && <Paragraph>{description}</Paragraph>}
      {ctas && ctas.length > 0 && (
        <div className="inline-flex mt-6 space-x-4">
          {ctas.map((cta) => (
            <Button
              colour={cta.colour || 'pink'}
              appearance={cta.appearance}
              href={cta.href}
              key={cta.href}
            >
              {cta.label || 'Learn more'} &#8594;
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
